module.exports = __webpack_public_path__ + "img/function.aaff78a3.png";